import { apiClient } from "../index";

const ME_PATH = "/api/v1/auth/me";
const CHANGE_PASSWORD_PATH = "/api/v1/auth/change-password";

export async function getUserProfile() {
  return apiClient.get(ME_PATH);
}

export async function changePassword(
  currentPassword,
  newPassword,
  confirmNewPassword,
) {
  const payload = {
    current_password: currentPassword,
    new_password: newPassword,
    confirm_new_password: confirmNewPassword,
  };
  return apiClient.post(CHANGE_PASSWORD_PATH, payload);
}
